import {BriefPanelName, PanelTypeEnum, Unit, VAxisType} from '@balrog/component/common';
import {ProfileInterface} from './interface/profile.interface';
import { AccessPermissionEnum } from '@balrog/core/model/const';

export class RetrofitJFCProfile implements ProfileInterface {
    statuses = {
        RETROFIT_JFC_STAT_OUT_STATE_D1: {title: 'Dmuchawa D1'},
        RETROFIT_JFC_STAT_OUT_STATE_P1: {title: 'Pompa P1'},
        RETROFIT_JFC_STAT_OUT_STATE_ALARM: {title: 'Alarm'},
    };
    // alarmy
    alarms = {
        RETROFIT_JFC_ALARM_PROGRAM_MEMORY_ERROR: {title: 'Błąd pamięci nastaw'},
        RETROFIT_JFC_ALARM_SETTINGS_MEMORY_ERROR: {title: 'Błąd pamięci programu'},
        RETROFIT_JFC_ALARM_RTC_ERROR: {title: 'Awaria zegara RTC'},
        RETROFIT_JFC_ALARM_WRONG_CURRENT_D1: {title: 'Błąd pomiaru prądu D1'},
        RETROFIT_JFC_ALARM_WRONG_CURRENT_P1: {title: 'Błąd pomiaru prądu P1'},
    };

    briefPanel = {
        name: BriefPanelName.ELEKTROMIZ_RETROFIT_JFC
    };

    dashBoard = {
        panelType: PanelTypeEnum.ELEKTROMIZ_RETROFIT_JFC
    };

    historyBoard = {
        content: [
            {
                paramId: 'RETROFIT_JFC_VAL_CURRENT_D1',
                unit: Unit.A,
                vAxisType: VAxisType.A.valueOf(),
                type: 'stepped'
            },
            {
                paramId: 'RETROFIT_JFC_VAL_CURRENT_P1',
                unit: Unit.A,
                vAxisType: VAxisType.A.valueOf(),
                type: 'stepped'
            },
        ]
    };

    listBoard = {
        title: 'Konfiguracja',
        content: [
        {
            paramId: 'RETROFIT_JFC_VAL_SOFT_VER',
            unit: Unit.NONE,
            step: 0.01,
        },
        {
            title: 'Odczyty',
            type: 'MENU',
            content: [
                {
                    paramId: 'RETROFIT_JFC_VAL_CURRENT_D1',
                    step: 0.1,
                    unit: Unit.A,
                },
                {
                    paramId: 'RETROFIT_JFC_VAL_CURRENT_P1',
                    step: 0.1,
                    unit: Unit.A,
                },
                {
                    paramId: 'RETROFIT_JFC_VAL_CONTROLLER_STATE',
                    readPermission: AccessPermissionEnum.INSTALLER.valueOf(),
                    options: [
                        {value: '0', name: 'Oczekiwanie'},
                        {value: '1', name: 'Faza I'},
                        {value: '2', name: 'Faza II'},
                        {value: '3', name: 'Faza III'},
                        {value: '4', name: 'Faza IV'},
                        {value: '5', name: 'Faza V'},
                    ]
                },
                {
                    paramId: 'RETROFIT_JFC_VAL_CONTROLLER_AERATION_SUB_PHASE',
                    readPermission: AccessPermissionEnum.INSTALLER.valueOf(),
                    options: [
                        {value: '0', name: 'Praca'},
                        {value: '1', name: 'Pauza'},
                    ]
                },
            ]
        },
        {
            title: 'Dane historyczne',
            type: 'MENU',
            content: [
                {
                    paramId: 'RETROFIT_JFC_VAL_TOTAL_TURN_ON_TIME_D1',
                    unit: Unit.SEC,
                },
                {
                    paramId: 'RETROFIT_JFC_VAL_TOTAL_TURN_ON_TIME_P1',
                    unit: Unit.SEC,
                },
                {
                    paramId: 'RETROFIT_JFC_VAL_TOTAL_TURN_ON_TIME_ALARM',
                    unit: Unit.SEC,
                },
            ]
        },
            {
                title: 'Nastawy',
                type: 'MENU',
                readPermission: AccessPermissionEnum.INSTALLER.valueOf(),
                content: [
                {
                    paramId: 'RETROFIT_JFC_SETP_AERATION_TIME_WORK',
                    unit: Unit.SEC,
                    step: 60,
                },
                {
                    paramId: 'RETROFIT_JFC_SETP_AERATION_TIME_PAUSE',
                    unit: Unit.SEC,
                    step: 60,
                },
                {
                    paramId: 'RETROFIT_JFC_SETP_SEDIMENTATION_TIME',
                    unit: Unit.SEC,
                    step: 60,
                },
                {
                    paramId: 'RETROFIT_JFC_SETP_PUMP_OUT_TIME',
                    unit: Unit.SEC,
                    step: 60,
                },
                {
                    paramId: 'RETROFIT_JFC_SETP_SEDIMENTATION_FLOAT_TIME',
                    unit: Unit.SEC,
                    step: 60,
                },
                {
                    paramId: 'RETROFIT_JFC_SETP_PUMP_OUT_FLOAT_TIME',
                    unit: Unit.SEC,
                    step: 60,
                },
                {
                    paramId: 'RETROFIT_JFC_SETP_MIN_D1_CURRENT',
                    unit: Unit.A,
                    step: 0.1,
                },
                {
                    paramId: 'RETROFIT_JFC_SETP_MAX_D1_CURRENT',
                    unit: Unit.A,
                    step: 0.1,
                },
                {
                    paramId: 'RETROFIT_JFC_SETP_MIN_P1_CURRENT',
                    unit: Unit.A,
                    step: 0.1,
                },
                {
                    paramId: 'RETROFIT_JFC_SETP_MAX_P1_CURRENT',
                    unit: Unit.A,
                    step: 0.1,
                },
            ]
        }
    ]};
    scheduleBoard = null;
}
